/*
 * ElManar CRO layer — 2026-09-19
 * Controls the first-visit welcome bar. Everything else in the CRO layer is
 * CSS or Liquid; this is the only behaviour that needs script.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mnr_welcome_seen_v1';
  var REVEAL_DELAY_MS = 6000;
  var REVEAL_SCROLL_RATIO = 0.25;

  // Private browsing and locked-down WebViews throw on storage access rather
  // than returning null, and a large share of this store's traffic arrives in
  // the Facebook and Instagram in-app browsers.
  function hasSeen() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSeen() {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* Storage unavailable: the bar simply shows again next visit. */
    }
  }

  function init() {
    var bar = document.getElementById('MnrWelcome');
    if (!bar) return;

    // Someone already in the funnel does not need a welcome message.
    var path = window.location.pathname;
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;

    if (hasSeen()) return;

    var revealed = false;
    var timer = null;

    function dismiss() {
      markSeen();
      bar.classList.remove('is-open');
      window.setTimeout(function () {
        bar.hidden = true;
      }, 350);
    }

    function reveal() {
      if (revealed) return;
      revealed = true;

      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);

      bar.hidden = false;
      // Force a reflow so the transform transition runs from its off-canvas
      // start state instead of being collapsed into the same frame.
      void bar.offsetHeight;
      bar.classList.add('is-open');
    }

    function onScroll() {
      var scrolled = window.pageYOffset || document.documentElement.scrollTop;
      if (scrolled > window.innerHeight * REVEAL_SCROLL_RATIO) reveal();
    }

    timer = window.setTimeout(reveal, REVEAL_DELAY_MS);
    window.addEventListener('scroll', onScroll, { passive: true });

    var closeButton = bar.querySelector('[data-mnr-welcome-close]');
    if (closeButton) closeButton.addEventListener('click', dismiss);

    var cta = bar.querySelector('[data-mnr-welcome-cta]');
    // Mark as seen on the way out so the bar does not reappear on the
    // collection page the shopper just asked for.
    if (cta) cta.addEventListener('click', markSeen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
